import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Alert, Button, Col, Form, Input, notification, Row, Select, Spin } from 'antd';
import _ from 'lodash';

import * as customerController from '../../../../../../services/api/customer';
import { genderOptions, customerQualificationOptions, customerWorkExperienceOptions } from '../../../../../../utils/options';
import './CustomerForm.scss';

const FormItem = Form.Item;
const Option = Select.Option;
const TextArea = Input.TextArea;

export class CustomerForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            isLocked: false,
        };
    }

    handleSubmit(e) {
        const { history, match, form } = this.props;
        const customerId = match.params.customerId;
        const isCreateNewCustomer = match.params.customerId === undefined;

        e.preventDefault();
        this.setState({ isLoading: true });

        form.validateFields((err, values) => {
            if (!err) {
                (isCreateNewCustomer ? customerController.createCustomer(values) : customerController.updateCustomer(customerId, values))
                .then((res) => res.json())
                    .then((json) => {
                        this.setState({ isLoading: false });
                        history.push('/dashboard/admin/customer');
                    })
                    .catch((err) => {
                        notification.error({
                            message: 'Unexpected Error',
                            description: 'Please report this issue to engineer.',
                            duration: 0
                        });
                        this.setState({ isLoading: false });
                    })
            } else {
                this.setState({ isLoading: false });
            }
        });
    }

    handleUnlock(e) {
        const { match } = this.props;
        const customerId = match.params.customerId;

        this.setState({ isLoading: true });

        customerController.unlockCustomer(customerId)
            .then((res) => res.json())
            .then((json) => {
                if (!json.is_locked) {
                    notification.success({
                        message: 'Unlock Succeed',
                        description: 'Customer unlocked successfully.',
                    });

                    this.fetchCustomer();
                } else
                    notification.error({
                        message: 'Unlock Failed',
                        description: 'Customer with duplicate email/contact number found. Please check again.',
                    });

                this.setState({ isLoading: false });
            })
            .catch((err) => {
                notification.error({
                    message: 'Unexpected Error',
                    description: 'Please report this issue to engineer.',
                    duration: 0
                });
                this.setState({ isLoading: false });
            })
    }

    fetchCustomer() {
        const { match, form } = this.props;
        const customerId = match.params.customerId;

        this.setState({ isLoading: true });

        customerController.getCustomer(customerId)
            .then((res) => res.json())
            .then((json) => {
                const { name, gender, email, contact_number, email2, contact_number2, company_name, occupation, qualification, work_experience, remarks, is_locked } = json;
                form.setFieldsValue({ name, gender, email, contact_number, email2, contact_number2, company_name, occupation, qualification, work_experience, remarks });
                this.setState({ isLoading: false, isLocked: is_locked });
            })
    }

    componentDidMount() {
        const { match, form } = this.props;
        const customerId = match.params.customerId;

        if (customerId === undefined) {
            form.resetFields();
        } else {
            this.fetchCustomer();
        }
    }

    render() {
        const { history, match, form, isAdmin } = this.props;
        const { isLoading, isLocked } = this.state;

        const isDisabled = isLocked && !isAdmin;
        const lockedMessage = isAdmin ? 'This customer is locked due to duplicate email/contact number. Modify/delete it to solve the issue.' : 'This customer is locked due to duplicate email/contact number. Only Admin can modify it.';

        const { getFieldDecorator } = form;

        const customerId = match.params.customerId;
        const isCreateNewCustomer = customerId === undefined;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };

        const genderOptionComponents = _.map(genderOptions, (genderOption) => <Option key={genderOption} value={genderOption}>{genderOption}</Option>);
        const qualificationOptions = _.map(customerQualificationOptions, (option) => <Option key={option} value={option}>{option}</Option>);
        const workExperienceOptions = _.map(customerWorkExperienceOptions, (option) => <Option key={option} value={option}>{option}</Option>);

        return (
            <Spin spinning={isLoading}>
                <Form className="CustomerForm" onSubmit={(e) => this.handleSubmit(e)}>
                    {
                        isLocked && 
                        <Row gutter={32}>
                            <Col span={24}>
                                <Alert type="error" message={lockedMessage}/>
                            </Col>
                        </Row>
                    }
                    <Row gutter={32}>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Name">
                                {
                                    getFieldDecorator('name', {
                                        rules: [{
                                            required: true,
                                            message: 'This field is required.'
                                        }],
                                    })(
                                        <Input placeholder="Input Customer Name"  disabled={isDisabled}/>
                                    )
                                }
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Gender">
                                {
                                    getFieldDecorator('gender')(
                                        <Select placeholder="Select Customer Gender" disabled={isDisabled}>
                                            {genderOptionComponents}
                                        </Select>
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Email">
                                {
                                    getFieldDecorator('email')(
                                        <Input placeholder="Input Customer Email" disabled={isDisabled}/>
                                    )
                                }
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Contact Number">
                                {
                                    getFieldDecorator('contact_number')(
                                        <Input placeholder="Input Customer Contact Number" disabled={isDisabled}/>
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Email 2">
                                {
                                    getFieldDecorator('email2')(
                                        <Input placeholder="Input Another Customer Email(if any)" disabled={isDisabled}/>
                                    )
                                }
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Contact Number 2">
                                {
                                    getFieldDecorator('contact_number2')(
                                        <Input placeholder="Input Another Customer Contact Number(if any)" disabled={isDisabled}/>
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Company Name">
                                {
                                    getFieldDecorator('company_name')(
                                        <Input placeholder="Input Customer Company Name"  disabled={isDisabled}/>
                                    )
                                }
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Occupation">
                                {
                                    getFieldDecorator('occupation')(
                                        <Input placeholder="Input Customer Occupation" disabled={isDisabled}/>
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Qualification">
                                {getFieldDecorator('qualification')(
                                    <Select placeholder="Select Qualification" disabled={isDisabled}>
                                        {qualificationOptions}
                                    </Select>
                                )}
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem {...formItemLayout} label="Work Experience">
                                {getFieldDecorator('work_experience')(
                                    <Select placeholder="Select Work Experience" disabled={isDisabled}>
                                        {workExperienceOptions}
                                    </Select>
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={24}>
                            <FormItem 
                                labelCol={{ xs: { span: 24 }, sm: { span: 4 } }}
                                wrapperCol={{ xs: { span: 24 }, sm: { span: 20 } }}
                                label="Remarks"
                            >
                                {getFieldDecorator('remarks')(
                                    <TextArea
                                        placeholder="Input Remarks" 
                                        autosize={{ minRows: 4, maxRows: 4 }} 
                                        disabled={isDisabled}
                                    />
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <FormItem>
                            <Button onClick={(e) => history.push('/dashboard/admin/customer')}>Back</Button>
                            {' '}
                            <Button type="primary" htmlType="submit" disabled={isDisabled}>{isCreateNewCustomer ? 'Create' : 'Update'}</Button>
                            {' '}
                            { isLocked && isAdmin && <Button className="merge-btn" type="primary" onClick={(e) => this.handleUnlock()}>Unlock</Button>}
                        </FormItem>
                    </Row>
                </Form>
            </Spin>
        );
    }
}

const WrappedCustomerForm = Form.create()(CustomerForm);
const mapStateToProps = (state) => ({
    isAdmin: state.user.isAdmin
})
export default connect(mapStateToProps)(withRouter(WrappedCustomerForm));


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/CustomerManagementPage/components/CustomerForm/CustomerForm.js